import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {toast} from 'react-toastify';
import ReactPlayer from 'react-player';
import Draggable from 'react-draggable';

import ErrorMsg from "../common/ErrorMsg";
import loadingGIF from "../../public/assets/images/loading.gif";
import videoIcon from "../../public/assets/images/video_icon.png";


export default class TrainingVideosModal extends React.Component {

    state = {
        isLoading: false,
        showVideo: false,
        video: {}
    }

    componentDidMount = () => {
        this.getVideos();
    }

    getVideos = async () => {
        try {
            let result = await this.props.getTrainingVideoList();           
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>);
        }
    }

    showVideos = (video) => {
        this.setState({showVideo: true, video});
    }

    closeVideo = () => {
        this.setState({showVideo: false, video: {}});
    }

    renderVideos = () => {
        return this.props.staffDashboard.trainingVideoList.map(video => 
            <div className="d-flex mb-3 cursor-pointer"
                onClick={() => this.showVideos(video)}
            >
                <div className="min-width-25">
                    <img src={videoIcon} className="video-btn"
                        alt="video" height="18" width="18"
                    />
                </div>
                <div>{video.title}</div>
            </div>
        );
    }

    render = () => {
        const {isLoading, showVideo, video} = this.state;
        const {modal, toggleModal} = this.props;

        return (
            <Modal isOpen={modal} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>
                    Training videos
                </ModalHeader>
                <ModalBody className="bg-white">
                    {showVideo && 
                        <Draggable defaultPosition={{x: 150, y: -50}}>
                            <div className="border draggableDiv">
                                <div className="dragger" title="Grab and Drag">
                                    {video.title}
                                    <i className="font-18 fa fa-times-circle close" 
                                        onClick={this.closeVideo}></i>
                                </div>
                                <div className="player-wrapper">
                                    <ReactPlayer url={video.link} 
                                        playing controls width='100%' height='100%'
                                    />
                                </div>
                                <div className="dragger" title="Grab and Drag">
                                    :::::::
                                </div>
                            </div>
                        </Draggable>
                    }

                    {this.renderVideos()}
                    
                    {isLoading && 
                        <p className="loading-gif">
                            <img src={loadingGIF} alt="Loading..." width="32" height="32"/>
                        </p>
                    }
                </ModalBody>
                <ModalFooter>
                    <Button className='btn btn-secondary' onClick={toggleModal}>Close</Button>
                </ModalFooter>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/staffDashboardNav/TrainingVideos.js